define.alias("shared/helpers/format-date", "media/helpers/format-date");